<template>
  <div>

    <data-table
      :id="getTableRef()"
      :ref="getTableRef()"
      :title="title"
      :url="url"
      :table-ref="getTableRef()"
      :fields="fields"
      :hideTop="hideTop"
      :showSearch="showSearch"
      :org-badge="orgBadge"
      :showRefresh="showRefresh"
      :searchPlaceholder="searchPlaceholder"
      :add-action="(uploadInfo || uploadCallback) && allowAddCategory ? addFileAction : null"
      :add-props="addProps"
      :show-pagination="showPagination"
      :options="detailProps"
      detail-component="file-detail-row">

      <template #file-action="props">
        <el-form>
          <file-upload
            v-if="!props.rowData.url"
              :text="'Upload ' + props.rowData.title"

              :url="getEndpoint('/upload/' +
                props.rowData.id + '/site/' +
                props.rowData.site_id + '/' + urlSafeName(userName()))"

              :delete-file-only="true"
              :after-upload="uploaded"
              :after-delete="afterDelete"
              :model="getModel(props.rowData.id)"
              type="primary"
              :show-tooltip="true"
              :tooltip="uploadTooltip(props.rowData)"
              :size="size"
              :additional-data="uploadInfo"
              :disabled="isViewOnly() || disableForm || disableUpload(props.rowData) || uploadLocked">
          </file-upload>

          <div v-else>
              <el-button
                :type="getType(props.rowData)"
                  @click="download(props.rowData)"
                  :size="size"
                  :disabled="isViewOnly()">
                  <b>Download {{props.rowData.title}}</b>
                </el-button>
                <p v-if="showFileName && isDesktop"><small>
                  <i>{{props.rowData.name}}</i>
                </small></p>
                <!-- XOL-526 (UX §1.4): narrow-layout attribution — the exact
                     complement of the "Uploaded by" column's hidden-sm-and-down,
                     so it is never duplicated and never missing. -->
                <p class="hidden-md-and-up" v-if="props.rowData.uploadOrgShortName || props.rowData.upload_by"><small>
                  Uploaded by
                  <org-badge v-if="props.rowData.uploadOrgShortName"
                    :organisation="{ shortName: props.rowData.uploadOrgShortName, colourCode: props.rowData.uploadOrgColourCode }" />
                  <span v-if="isMyOrgUpload(props.rowData)" class="text-muted"> &middot; your organisation</span>
                  <span class="text-muted">{{props.rowData.upload_by}}</span>
                </small></p>
            </div>
          </el-form>
      </template>

      <template #uploaded-by="props">
        <div v-if="props.rowData.uploadOrgShortName">
          <org-badge :organisation="{ shortName: props.rowData.uploadOrgShortName, colourCode: props.rowData.uploadOrgColourCode }" />
          <small v-if="isMyOrgUpload(props.rowData)" class="text-muted"> &middot; your organisation</small>
          <br />
          <small class="text-muted">{{props.rowData.upload_by}}</small>
        </div>
        <small v-else-if="props.rowData.upload_by" class="text-muted">{{props.rowData.upload_by}}</small>
      </template>

    </data-table>

  </div>
</template>


<script>
import Vue from 'vue'

import PostMixins from '@/mixins/PostMixins'
import ArrayMixins from '@/mixins/ArrayMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import FormattingMixins from '@/mixins/FormattingMixins'

import FileAction from '@/components/actions/FileAction'

import FileDetails from '@/components/tables/details/FileDetails'

import FileUpload from '@/components/atoms/files/FileUpload'
import FileDownload from '@/components/atoms/files/FileDownload'

Vue.component('file-detail-row', FileDetails)

export default {
  mixins: [PostMixins, ArrayMixins, DateMixins, NumberMixins, FormattingMixins],

  components: {
    FileAction,
    FileDownload,
    FileUpload
  },

  props: {
    siteId: {
      type: Number,
      default: null
    },

    type: {
      type: String,
      default: null
    },

    typeId: {
      type: Number,
      default: null
    },

    step: {
      type: Number,
      default: null
    },

    partyNo: {
      type: Number,
      default: null
    },

    stepData: {
      type: Object,
      default: null
    },

    orgBadge: {
      type: Object,
      default: null
    },

    title: {
      type: String,
      default: 'Files'
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    showFileName: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Search'
    },

    uploadInfo: {
      type: Object,
      default: null
    },

    uploadCallback: {
      type: Function,
      default: null
    },

    disableForm: {
      type: Boolean
//      default: false
    },

    tableRef: {
      type: String,
      default: 'filestable'
    },

    showPagination: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    uploadLocked: {
      type: Boolean,
      default: false
    },

    // XOL-526 (UX §1.3, U-C): a non-Tower-Co viewer only gets Category on the
    // slot(s) where its own upload is enabled. Tower Co is unaffected — its
    // gate is (uploadInfo || uploadCallback) alone, unchanged.
    allowAddCategory: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    url: function () {
      return '/files/' + (this.siteId
        ? 'site/' + this.siteId + '/' + this.type : this.type) +
         (this.typeId ? '/' + this.typeId : '') +
         (this.step ? (this.siteId ? '/' : '/null/null/') + this.step + (this.partyNo ? '/' + this.partyNo : '')
        : (this.siteId ? '/null' : '/null/null') + (this.partyNo ? '/' + this.partyNo : ''))
    }
  },

  watch: {
    stepData (value) {

      if (this.addProps.copyExisting && value && value.stepNo) {
        this.addProps.copyExisting.step = value.stepNo
        this.addProps.copyExisting.partyNo = this.partyNo
      }
    },

    // XOL-526: DataTable.onCellClicked only assigns `data.options = this.options`
    // ONCE per row (guarded by `!data.options`), and it assigns the SAME object
    // reference rather than cloning it — so a row's `options` stays in sync with
    // `detailProps` for any key that already existed when the row first opened,
    // as long as we MUTATE `detailProps` in place rather than replacing it.
    // `uploadLocked` is a prop (unlike `disableForm`, which is static per mount),
    // so it needs this explicit sync.
    uploadLocked (value) {
      this.detailProps.uploadLocked = value
    }
  },

  methods: {
    getTableRef () {
      return this.tableRef + '-' + (this.partyNo ? this.partyNo : this.rand)
    },

    formatKiloBytes (value) {
      if (value && value > 0) {
        return '<b>' + this.formatInteger(value / 1000) + '</b>k'
      } else {
        return ''
      }
    },

    // XOL-526 (UX §1.4, U-D): is this row's uploader the VIEWER's own org?
    // A method, not a computed keyed on `row` — re-evaluates once org()
    // hydrates, and every row needs its own answer.
    isMyOrgUpload (row) {
      var me = this.org()
      return !!(row && row.upload_org_id !== null && row.upload_org_id !== undefined &&
        me && me.id !== null && me.id !== undefined &&
        Number(row.upload_org_id) === Number(me.id))
    },

    refreshTable () {
      this.$events.emit(this.getTableRef() + '-refresh-table')
    },

    getModelKey (id) {
      return this.getTableRef() + 'Upload' + id
    },

    getModel (id) {
      var key = this.getModelKey(id)
      var arr = this.key(key, this.fileUploads)

      if (arr) {
        return arr
      } else {
        this.fileUploads.push({[key]: []})
        return this.key(key, this.fileUploads)
      }
    },

    clearModel (id) {
      var key = this.getModelKey(id)
      var arr = this.key(key, this.fileUploads)

      // XOL-526: `key()` always returns the FIRST list entry matching this
      // key, forever — pushing a fresh empty array (the old approach) never
      // gets seen again, so the stale entry (and every FileUpload bound to
      // it via getModel()) never actually clears. Mutate the SAME array
      // in place instead, so every existing binding sees it empty too.
      if (arr) {
        arr.splice(0, arr.length)
      }
    },

    // XOL-526: FileDetails calls this (via detailProps.onFileRemoved) right
    // after a successful Remove, so a re-mounted FileUpload for this row
    // (the v-if flips back to "Upload" once the row's url is nulled) sees an
    // empty model instead of the just-deleted file — without this, the
    // upload button stayed disabled until a full page reload.
    onDetailFileRemoved (id) {
      this.clearModel(id)
    },

    getType (row) {
      return row.approved
          ? 'success' : row.downloaded
          ? 'info' : (row.state && row.state.status === 'Rejected' ? 'danger' : 'warning')
    },

    disableUpload (row) {
      if (this.stepData && this.stepData.stepNo) {
        return !(row.step === this.stepData.stepNo && row.partyNo === this.stepData.partyNo)
      } else {
        return false
      }
    },

    // XOL-526 (UX §1.2, U-B): precedence order matters — the first matching
    // condition wins. `stepData && row.partyNo !== stepData.partyNo` is the
    // NEW "this file is in the other party's tab" case (checked before
    // disableUpload's own-step check, which would otherwise fire first and
    // give the wrong reason on the Tower Co's tab).
    uploadTooltip (row) {
      if (this.isViewOnly()) return 'This request is read-only and cannot be modified.'
      if (this.disableForm) return 'This request is no longer active. Files can\'t be uploaded.'

      if (this.stepData && Number(row.partyNo) !== Number(this.stepData.partyNo)) {
        var org = this.orgBadge && this.orgBadge.shortName ? this.orgBadge.shortName : 'another organisation'
        return 'This file is in ' + org + '\'s documents. You can only upload to your own tab.'
      }

      if (this.disableUpload(row)) return 'This file belongs to a different workflow step.'
      if (this.uploadLocked) return 'This step has been completed. Uploads are locked until a manager re-opens it.'
      return 'Upload PDF or image files (png, jpg, bmp) less than 8MB in size.'
    },

    uploaded (file, fileList) {
      this.refreshTable()
      fileList = []

      if (this.uploadCallback) {
        this.uploadCallback(file, this.uploadInfo)
      }

    },

    download (row) {
      var dwUrl = this.getEndpoint('file/download/' + row.url + '/' + this.urlSafeName(row.name))
      this.downloadFile(dwUrl)

      row.downloaded = true
      row.lastDownload_at = this.formatDateTimeSql(new Date())
      row.lastDownload_by = this.userName()

      // XOL-526 (A4): send only the three stamp keys, not the full row — a
      // non-Tower-Co caller's PUT /file now applies only these and silently
      // ignores everything else, so sending the whole row invited a 403 (or a
      // future field the API refuses) for no benefit. The Tower Co's stamp is
      // unaffected: the API still applies exactly these three either way.
      this.saveForm(this, '/file', row.id,
        { downloaded: row.downloaded, lastDownload_at: row.lastDownload_at, lastDownload_by: row.lastDownload_by },
        'File Details', null, null, false)
    },

    afterDelete (data = null) {

      if (data) {

        this.fileData.url = null
        this.fileData.downloaded = false

        this.clearModel(data.id)
      }

      this.refreshTable()
    },

    info (rowData, stepNo) {

      var data = {
        info: {},
        sendTo: []
      }

      if (rowData && rowData.state && rowData.emails) {

        var prop = this.isTelco() ? 'tower' : 'telco'

        if (!rowData.emails[prop]) {
          console.error('OLD FORMAT for state.emails:', rowData.emails)
        } else {
          for (var i = 0; i < rowData.emails[prop].length; i++) {
            if (rowData.emails[prop][i] && !data.sendTo.includes(rowData.emails[prop][i])) {
              data.sendTo.push(rowData.emails[prop][i])
            }
          }

        }

        data.info.step = stepNo
        data.info.sendMail = rowData.emails.sendMail ? rowData.emails.sendMail : false
        data.info.rts_id = rowData.id ? rowData.id : null
        data.info.site_id = rowData.site_id ? rowData.site_id : null
        data.info.towerCoName = this.xolasClient().name ? this.xolasClient().name : 'Xolas Towers'
        data.info.email = this.xolasClient().email ? this.xolasClient().email : 'support@xolas.io'
        data.info.phone = this.xolasClient().phone ? this.xolasClient().phone : null
        data.info.siteName = rowData.site && rowData.site.siteName ? rowData.site.siteName : 'No Site Selected'
        data.info.siteId = rowData.site && rowData.site.siteId ? rowData.site.siteId : 'N/A'
        data.info.telcoSiteId = rowData.site && rowData.site.telcoSiteId ? rowData.site.telcoSiteId : 'N/A'
        data.info.sharerName = rowData.organisation && rowData.organisation.name ? rowData.organisation.name : 'No Sharer Selected'
      }
    }
  },

  data () {
    return {
      rand: null,
      fileData: this.rowData,

      // XOL-526: `uploadLocked` must be present from the START — Vue 2 can't
      // make a property added to an already-observed object reactive later.
      // `onFileRemoved` follows the same seed-from-the-start pattern, even
      // though it's a function (not a value FileDetails watches) — keeping
      // every detailProps key seeded here, rather than added piecemeal,
      // avoids re-litigating this Vue 2 gotcha per key.
      detailProps: {
        disableForm: this.disableForm,
        uploadLocked: this.uploadLocked,
        onFileRemoved: this.onDetailFileRemoved
      },

      addFileAction: FileAction,

      addProps: {
        showCaption: false,
        showRef: false,
        tableRef: this.getTableRef(),

        copyExisting: {
          site_id: this.siteId,
          workflow_id: this.workflow_id,
          typeKey: this.siteId ? 'site' : this.type,
          type_id: this.siteId ? this.siteId : this.typeId,
          processKey: this.siteId ? this.type : null,
          process_id: this.siteId ? this.typeId : null,
          step: this.step,
          seqNo: this.stepData ? this.stepData.seqNo : null,
          partyNo: this.partyNo ? this.partyNo : (this.stepData ? this.stepData.partyNo : null)
        }

      },
      fileUploads: [],
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: '__slot:file-action',
          title: 'File'
        },
        // XOL-526 (UX §1.4, U-D): replaces the transparent upload_by filler
        // column. `hidden-sm-and-down` is the exact complement of the
        // narrow-layout `hidden-md-and-up` inline attribution above, so the
        // signal is never duplicated and never missing.
        {
          name: '__slot:uploaded-by',
          title: 'Uploaded by',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'size',
          title: 'Size',
          callback: this.formatKiloBytes,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down u-pull-right'
        }
      ]
    }
  },  // data

  created () {
//    console.log('type', this.type, 'typeNo', this.typeId, 'stepNo', this.step, 'partyNo', this.partyNo)
    this.rand = (this.rand ? this.rand : this.randBetween())

    this.addProps.tableRef = this.getTableRef()
  }
}

</script>

<style scoped>
a {text-decoration: none;}
</style>
